import { render } from "./warentyClaim.vue?vue&type=template&id=f2012ea0"
import script from "./warentyClaim.vue?vue&type=script&lang=js"
export * from "./warentyClaim.vue?vue&type=script&lang=js"

import "./warentyClaim.vue?vue&type=style&index=0&id=f2012ea0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__